import { $http } from '../request'
import Qs from 'qs'
import domain from '@/server-config/domain.config'

export const getGlobalCatch = () => $http.get({
  baseURL: '/',
  url: '/api/global-cache',
  server: true
})
  .then((r: any) => r.data)

export interface ISendCode {
  PfxRegion?: number | string
  type?: number,
  phone?: string
  email?: string,
  phoneRegionId?: number | string
}
export const sendCode = (params: ISendCode) => $http.post({ 
  url: '/sms/code',
  body: params 
})
  .then((r: any) => r)
  
export const sendEmailCode = (params: ISendCode) => $http.post({ 
  url: '/email/code',
  body: params 
})
  .then((r: any) => r)

/** 申请 WhatsApp 验证码（登录 type=1） */
export const sendWhatsAppCode = (params: ISendCode) => {
  const headers: any = {}
  if (params.PfxRegion) {
    headers['Pfx-Region'] = params.PfxRegion
  }
  return $http.post({
    url: '/whatsapp/code',
    body: params,
    headers
  }).then((r: any) => r)
}

export interface ICodeLogin {
  code: number | string
  sn: string
  PfxRegion?: number | string
  phone?: number | string
  email?: number | string
  referCode?: string
  referSource?: string
  referSourceId?: string,
  phoneRegionId?: number | string
}
export const loginByCode = (params: ICodeLogin) => {
  const headers: any = {}

  if(params.PfxRegion) {
    headers['Pfx-Region'] = params.PfxRegion
  }
  params.phoneRegionId = params.PfxRegion
  
  return $http.post({
    url: '/v2/login-by-code',
    loading: true,
    body: params,
    headers
  }).then((r: any) => r.data)
}

/** WhatsApp 验证码登录/注册 */
export const loginByWhatsApp = (params: ICodeLogin) => {
  const headers: any = {}

  if(params.PfxRegion) {
    headers['Pfx-Region'] = params.PfxRegion
  }
  if(params.phoneRegionId == null && params.PfxRegion) {
    params.phoneRegionId = params.PfxRegion
  }

  return $http.post({
    url: '/v2/login-by-whatsapp',
    loading: true,
    body: params,
    headers
  }).then((r: any) => r.data)
}

export const loginByEmail = (params: ICodeLogin) => $http.post({
  // url: '/register-by-email',
  url: '/login-by-email',
  body: params
}).then((r: any) => r.data)

export interface ILoginPwd {
  PfxRegion: number | string
  regionId: number | string
  account: string
  password: string
}
export const loginByPwd = (params: ILoginPwd) => $http.post({
  url: '/login-by-password',
  body: params,
  headers: {
    'Pfx-Region': params.PfxRegion
  }
}).then((r: any) => r.data)


export const loginGoogle = (idToken: string) => $http.post({
  url: '/login-by-google',
  body: { idToken }
}).then((r: any) => r.data)

// Google 账号是否为新创建
export const queryGoogleIsNew = (googleAccountId: string) => $http.get({
  url: '/login-by-google',
  params: { googleAccountId }
}).then((r: any) => r.data)

export const loginBindingGoogle = (idToken: string, googleAccountId: string) => $http.post({
  url: '/account/bind-google',
  body: { idToken, googleAccountId }
}).then((r: any) => r.data)

export interface ILoginFacebook{
  fbUserId: string
  fbUserName: string
  fbAccessToken: string
}

export const loginFacebook = (params: ILoginFacebook) => $http.post({ url: '/login-by-facebook', body: params }).then((r :any) => r.data)
// Facebook 账号是否为新创建
export const queryFacebookIsNew = (fbUserId: string) => $http.get({ url: '/login-by-facebook', params: { fbUserId } }).then((r :any) => r.data)
// facebook 绑定已有账号
export const loginFacebookBinding = (fbAccessToken: string, fbUserId: string) => $http.post({ url: '/account/bind-facebook', body: { fbAccessToken, fbUserId } }).then((r: any) => r.data)

export const getCategoryById = (id: number) => {
  const url = `/category/${id}/subs`

  return $http.get({ url, loading: true })
    .then((r: any) => r.data?.subs || [])
}
export const getFrontCategoryById = (id: number, type: 1 | 2 = 1, server: boolean = true) => {
  const url = `/front-category/${id}/subs?type=${type}`
  const isLoading = id === 0
  return $http.get({ url, loading: isLoading, server })
    .then((r: any) => r.data?.subs || [])
}

export interface ISetPwd { password: string, confirmPassword: string }
export const setPassword = (params: ISetPwd) => $http.post({ url: '/password', body: params })

export const setInvite = (code: string) => $http.post({ url: '/invite', body: { code }})

export const getSuggestions = <T=string[]>(keyword: string): Promise<T> => $http.get({ url: `/search/suggestions?text=${keyword}` }).then((r: any): T => r.data.suggestions || [])
/** 联想词库统计 */
export const suggestionClick = (keyword: string) => $http.post({ url: '/search/suggestion-click', body: { keyword }})

// export const getHotKeywords = <T=string[]>():Promise<T> => $http.get({ url: '/search-keys/hot' }).then((r: any):T => r.data)
export interface ISearchParams {
  skip?: number,
  size?: number,
  keywords?: string,
  priceFrom?: number | string
  priceTo?: number | string
  shipped?: string
  delivery?: string
  categoryIds?: number[] | string[]
  bigDiscountSaleId?: number
  sortBy?: number | string
  brandIds?: number | string
  storeId?: number | string
  storeCategoryIds?: number | string
  imageQuery?: string
  codSupported?: number[]
  prePaidSupported?: number
  fbkSupported?: number,
  frontCategoryId?:number | number[] | ''
  attrFilters?: any
  useSuggestion?: boolean
  promotionId?: number
}
export const search = (params: ISearchParams) => 
  $http
    .get({ baseURL: domain.LOCAL_BASE_URL, url: '/search', params, server: true })
    .then((r: any) => r.data)

export const searchByStoreId = (params: ISearchParams) =>
  $http
    .get({ baseURL: domain.LOCAL_BASE_URL, url: `/store/${params.storeId}/search`, params, server: true })
    .then((r: any) => r.data)

export const cartList = (loading: boolean = true, server: boolean = true) =>
  $http.get({ baseURL: domain.LOCAL_BASE_URL, url: '/v3/cart', server, loading }).then((r: any) => r.data)

export const getPromotionByCartId = (cid: number) =>$http.get({ url: `/cart-item-promotions/${cid}`, loading: true, server: false }).then((r: any) => r.data)

export interface IUpdateCart {
  count: number,
  checked: boolean,
  promotionId: number
}
export const updateCartByCid = (cid: number, params: IUpdateCart) =>
  $http.patch({ url: `/v3/cart-item/${cid}`, params, loading: false }).then((r: any) => r.data)

export const deleteCartByCid = (cid: number) =>
  $http.delete({ url: `/v3/cart-item/${cid}`, loading: true })

export const batchDeleteCartByCids = (cartItemIds: number[]) =>
  $http.delete({ url: '/cart-items', body: { cartItemIds: JSON.stringify(cartItemIds) }, loading: true })

export interface ICartCheckout {
  itemId: number
  promotionId: number
  internalLatestTrafficSourceModule?: string
  internalLatestTrafficSourceType?: string
  insideLatestTrafficSourceValue?: string
  internalFirstTrafficSourcePage?: string
  internalLatestTrafficSourcePage?: string
  isAd?: boolean | null
  isNewTag?: boolean | null
  isChoiceTag?: boolean | null
  requestId?: string | null
  algorithmModelName?: string | null
}
export const cartCheckout = (items: ICartCheckout[]) => {
  const dt = JSON.stringify(items)
  
  return $http.post({ 
    url: '/v2/cart-checkout',
    body: Qs.stringify({ items: dt }),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  })
}
  
export const getWishlist = (limit: number, lastId: number) => $http.get({ 
  url: `/wish/listings?limit=${limit}&lastId=${lastId}`,
}).then((r: any) => r.data)

export const delWishlist = (params: { listingId: number }) => $http.delete({ url: '/wish/listings', body: params })

export interface INewArrivalParams{ lastId: number, limit: number, categoryId?: number, categoryIds?: number[], keywords?: string }
export const newArrival = (params: INewArrivalParams, server: boolean = true) => $http.get({ 
  url: '/listings/new-arrival',
  params,
  baseURL: domain.LOCAL_BASE_URL,
  server
}).then((r: any) => r.data)

export const getFollowedStores = (params: IPayload) => $http.get({ url: '/followed-stores?skip=0&limit=10', params }).then((r: BaseResponse) => r.data)

export const delWishStoreById = (storeId: number) => $http.delete({ baseURL: domain.LOCAL_BASE_URL, url: `/store/${storeId}/follow`})

export const getRecentViews = (lastId: number, limit: number) => $http.get({ url: '/recent-views', params: { lastId, limit } }).then((r: any) => r.data)
export const deleteRecentViews = () => $http.delete({ url: '/recent-views', loading: true })

// 专题页数据
export const topicPageByCode = (code: string) => $http.get({ url: `/topic-page/${code}`, loading: true }).then((r: any) => r.data)

// 热搜词
export const getHomeHotKeywordsCache = () => $http.get({ url: '/search/hot-keywords', server: true }).then((r: any) => r.data)
// 缓存接口
// export const getHomeHotKeywordsCache = () => $http.get({ baseURL: '/', url: '/api/home/hot-keywords', server: true }).then((r: any) => r.data)

// 批量选中/取消 购物车
export const selectCartItems = (cartItemIds: number[], isSelected: boolean) => 
  $http.patch({ url: '/cart-items/selection', body: { cartItemIds: JSON.stringify(cartItemIds), isSelected: String(isSelected) } }).then((r: any) => r.data)

// 获取钱包数据
export const getWallet = () => $http.get({
  url: '/wallet'
}).then((r: any) => r)

/** 同 key 进行中的写 cache 合并，避免短时间重复打 set-params */
const urlCacheInflight = new Map<string, Promise<string>>()

export const setUrlCache = (params: any, key?: string): Promise<string> => {
  const cacheKey = String(key || '')
  if (cacheKey && urlCacheInflight.has(cacheKey)) {
    return urlCacheInflight.get(cacheKey)!
  }

  // 先占位再发请求，避免并发双检穿透导致同 key 打两次 set-params
  let resolveReq!: (v: string) => void
  let rejectReq!: (e: unknown) => void
  const placeholder = new Promise<string>((resolve, reject) => {
    resolveReq = resolve
    rejectReq = reject
  })
  if (cacheKey) {
    urlCacheInflight.set(cacheKey, placeholder)
  }

  $http
    .post({ baseURL: '/', url: '/api/url-cache/set-params', body: { params, key } })
    .then((r: any) => {
      resolveReq(r.data as string)
      return r.data as string
    })
    .catch((e) => {
      rejectReq(e)
      throw e
    })
    .finally(() => {
      if (cacheKey) {
        setTimeout(() => urlCacheInflight.delete(cacheKey), 500)
      }
    })

  return placeholder
}
export const getUrlCache = (key: string) =>
    $http.get({ baseURL: '/', url: `/api/url-cache/get-params?key=${key}` }).then((r: any) => r.data)
export const subscribeEmail = (email: string) => $http.post({ url: '/subscribe/email', body: { email } }).then((r: any) => r.data)
export const unsubscribeEmail = (email: string) => $http.delete({ url: '/subscribe/email', body: { email } }).then((r: any) => r.data)

// 获取容器URL
export const getCustomRouteRedirect = (params: any) => $http.get({ url: '/basecommon/v1/data-analysis/custom-route-redirect', params }).then((r: any) => r.data)